"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = require("moment");
function apiBookData(_state, getters, rootState, rootGetters) {
    var paxData = gatherPaxData(rootState, getters);
    var data = {
        cruise: gatherCruiseData(rootState, getters),
        affiliate: gatherAffiliate(rootState, getters, rootGetters),
        confirmations: gatherConfirmationData(rootState, getters),
        buyer: getBuyerData(rootState, getters, paxData),
        other: lodash_1.filter(paxData, function (pax) {
            return !pax.isPrimaryPax;
        }),
        transportations: undefined,
        insurance: undefined,
    };
    if (getters['transport/getType'] && getters['transport/getType'] !== 'none') {
        data.transportations = gatherTransportData(rootState, getters);
    }
    var insurance = getInsuranceData(rootState, getters);
    if (insurance) {
        data.insurance = insurance;
    }
    return data;
}
exports.default = apiBookData;
// private helper functions
function gatherCruiseData(_state, getters) {
    var _a = getters['persons/all'], adults = _a.adults, juveniles = _a.juveniles, children = _a.children;
    return {
        id: getters['generalCruise'].id,
        priceModel: getters['generalCruise'].priceModel,
        cabinCategory: getters['cabins/selectedCabinCategoryCode'],
        cabinNumber: getters['cabins/currentSelectionCabinNumber'],
        adults: adults,
        juveniles: juveniles,
        children: children,
        estimatedTotalPrice: getters['totalPrice'],
    };
}
function gatherAffiliate(_rootState, _getters, rootGetters) {
    var aId = rootGetters['booking/affiliate/agencyId'];
    return {
        // 30449 is the default agency ID for AIDA
        agencyId: aId === null ? '30449' : aId.agencyId,
    };
}
function gatherConfirmationData(_state, getters) {
    return {
        newsletterAccepted: false,
        bookingConditionsAccepted: false,
        privacyPolicyAccepted: false,
        tradingConditionsAccepted: getters['checkoutTerms'],
    };
}
function gatherPaxData(_state, getters) {
    var counter = 0;
    return lodash_1.map(getters['pax/all'], function (pax) {
        var p = {
            ageGroup: undefined,
            birthday: undefined,
            age: undefined,
            isPrimaryPax: undefined,
            bahnCard: undefined,
        };
        var keyList = [
            'sex',
            'firstName',
            'lastName',
            'birthday',
            'nationalityCode',
        ];
        for (var _i = 0, keyList_1 = keyList; _i < keyList_1.length; _i++) {
            var key = keyList_1[_i];
            if (pax[key].type === 'number') {
                p[key] = parseInt(pax[key].value, 10);
            }
            else {
                p[key] = pax[key].value;
            }
        }
        p.age = calcAge(p.birthday, getters['generalCruise'].departure);
        p.ageGroup = 'C';
        if (p.age > 15)
            p.ageGroup = 'J';
        if (p.age > 24)
            p.ageGroup = 'A';
        if (getters['checkoutPrimaryPaxId'] === counter)
            p.isPrimaryPax = true;
        counter += 1;
        return p;
    });
}
function gatherTransportData(state, getters) {
    var transportations = [];
    var transportation = getters['transport/getTransport'];
    var transportData = {
        type: getApiType(transportation.type),
        code: undefined,
        category: undefined,
        class: undefined,
        directionTrain: undefined,
        startDate: undefined,
        endDate: undefined,
        paxIds: undefined,
    };
    var category, startDate, endDate;
    if (transportation.type === 'rail') {
        var railTransport_1 = getters['transportRail/transport'];
        var direction = lodash_1.find(railTransport_1.transportations, function (trans) {
            return trans.tariffType === railTransport_1.selectedTariffType;
        }).direction;
        if (railTransport_1.departure) {
            category = railTransport_1.departureConfig.category;
            startDate = railTransport_1.departureConfig.date;
        }
        if (railTransport_1.arrival) {
            category = railTransport_1.arrivalConfig.category;
            endDate = railTransport_1.arrivalConfig.date;
        }
        transportData.code = railTransport_1.code;
        transportData.category = category;
        transportData.class = category;
        if (startDate) {
            transportData.startDate = startDate;
        }
        if (endDate) {
            transportData.endDate = endDate;
        }
        transportData.paxIds = getPaxIds(state, getters);
        transportData.directionTrain = direction;
        transportations.push(transportData);
    }
    else if (transportation.type === 'flight') {
        transportations = getters['transportAir/transportOptionsForBooking'];
        var rnfTransportations = getters['transportAir/rnfTransportations'];
        if (rnfTransportations.length) {
            transportations = rnfTransports(transportations, rnfTransportations);
        }
    }
    else if (transportation.type === 'flex') {
        transportations = getters['transportFlexFlights/transportOptionsForBooking'];
        var rnfTransportations = getters['transportFlexFlights/rnfTransportations'];
        if (rnfTransportations.length) {
            transportations = rnfTransports(transportations, rnfTransportations);
        }
    }
    return transportations;
}
function rnfTransports(transportations, rnfTransportations) {
    var filteredTransports = lodash_1.filter(transportations, function (trans) {
        return trans.type !== 'RNF';
    });
    rnfTransportations[0].class = rnfTransportations[0].transportationClass;
    rnfTransportations[0].directionTrain = rnfTransportations[0].direction;
    filteredTransports.push(rnfTransportations[0]);
    return filteredTransports;
}
function getPaxIds(_state, getters) {
    var countPax = 0;
    var paxIds = [];
    while (countPax < getters['pax/all'].length) {
        paxIds.push(countPax + 1);
        countPax += 1;
    }
    return paxIds;
}
function getInsuranceData(_state, getters) {
    if (getters['insurance/valid'] &&
        getters['insurance/selection'] &&
        getters['insurance/selection'] !== '%') {
        return getters['insurance/selection'];
    }
    return null;
}
function getApiType(type) {
    if (type === 'rail') {
        return 'RIT';
    }
    else if (type === 'flight') {
        return 'AIR';
    }
    else if (type === 'flex') {
        return 'FLX';
    }
    else if (type === 'bus') {
        return 'BUS';
    }
    else {
        return 'BUT';
    }
}
function getBuyerData(_state, getters, paxData) {
    var pax = lodash_1.find(paxData, function (pax) {
        return pax.isPrimaryPax;
    });
    if (!pax) {
        return null;
    }
    var countryList = getters['countryList'];
    var countryCodeForPhone = getters['checkoutCountryCode'].value;
    var countryPrefix = countryCodeForPhone
        ? countryList[countryCodeForPhone].phone
        : '';
    var phonePrefix = getters['checkoutPhonePrefix'].value;
    var phoneNumber = getters['checkoutPhone'].value;
    var fullPhoneNumber = countryPrefix + '-' + phonePrefix + '-' + phoneNumber;
    pax.street = getters['checkoutAddress'].value;
    pax.city = getters['checkoutCity'].value;
    pax.countryCode = getters['checkoutPostalCountryCode'].value;
    pax.email = getters['checkoutEmail'].value;
    pax.phone = fullPhoneNumber;
    pax.zipCode = getters['checkoutZipCode'].value;
    return pax;
}
function calcAge(birthday, cruiseDeparture) {
    var bd = moment_1.utc(birthday, 'DD.MM.YYYY');
    var cd = moment_1.utc(cruiseDeparture, 'DD.MM.YYYY');
    return cd.diff(bd, 'years');
}
//# sourceMappingURL=general_init_book_data.js.map